export const EDIT_CUE_ERROR = 'EDIT_CUE_ERROR';
export const CLEAR_EDIT_CUE = 'CLEAR_EDIT_CUE';
export const UPDATE_EDIT_CUE_PROPERTY = 'UPDATE_EDIT_CUE_PROPERTY';
export const GET_EDIT_CUE = 'GET_EDIT_CUE';
export const UPDATE_EDIT_CUE_VARIATION_PROPERTY =
  'UPDATE_EDIT_CUE_VARIATION_PROPERTY';
